import { Receipt } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface Props {
  subscriptions: any[];
  restaurants: any[];
  plans: any[];
}

const AdminSubscriptionsTab = ({ subscriptions, restaurants, plans }: Props) => {
  const formatCurrency = (v: number) => `R$ ${v.toFixed(2).replace(".", ",")}`;
  const statusColors: Record<string, string> = {
    active: "bg-success/10 text-success border-success/20",
    pending: "bg-warning/10 text-warning border-warning/20",
    cancelled: "bg-destructive/10 text-destructive border-destructive/20",
    expired: "bg-muted text-muted-foreground border-border",
  };
  const statusLabels: Record<string, string> = { active: "Ativa", pending: "Pendente", cancelled: "Cancelada" };

  return (
    <div className="space-y-4">
      <div>
        <h2 className="font-display font-semibold text-lg">Assinaturas</h2>
        <p className="text-xs text-muted-foreground">{subscriptions.length} assinaturas registradas</p>
      </div>

      {subscriptions.length === 0 ? (
        <div className="rounded-xl border border-border bg-card p-12 text-center text-muted-foreground">
          <Receipt className="h-8 w-8 mx-auto mb-2 opacity-30" /><p>Nenhuma assinatura</p>
        </div>
      ) : (
        <div className="rounded-xl border border-border bg-gradient-card shadow-card overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="text-xs text-muted-foreground border-b border-border">
                <th className="text-left p-4 font-medium">Restaurante</th>
                <th className="text-left p-4 font-medium">Plano</th>
                <th className="text-left p-4 font-medium">Valor</th>
                <th className="text-left p-4 font-medium">Ciclo</th>
                <th className="text-left p-4 font-medium">Status</th>
                <th className="text-left p-4 font-medium hidden md:table-cell">Período</th>
                <th className="text-left p-4 font-medium">Criação</th>
              </tr>
            </thead>
            <tbody>
              {subscriptions.map((sub) => {
                const rest = restaurants.find((r: any) => r.id === sub.restaurant_id);
                const plan = plans.find((p: any) => p.id === sub.plan_id);
                return (
                  <tr key={sub.id} className="border-b border-border/50 hover:bg-secondary/30">
                    <td className="p-4 text-sm font-medium">{rest?.name || sub.restaurant_id.slice(0, 8)}</td>
                    <td className="p-4 text-sm">{plan?.name || "—"}</td>
                    <td className="p-4 text-sm font-medium">{formatCurrency(Number(sub.amount))}</td>
                    <td className="p-4"><Badge variant="outline" className="text-[10px] capitalize">{sub.billing_cycle === "yearly" ? "Anual" : "Mensal"}</Badge></td>
                    <td className="p-4"><Badge className={`text-[10px] capitalize border ${statusColors[sub.status] || "bg-muted text-muted-foreground"}`}>{statusLabels[sub.status] || sub.status}</Badge></td>
                    <td className="p-4 text-xs text-muted-foreground hidden md:table-cell">
                      {sub.current_period_start ? `${new Date(sub.current_period_start).toLocaleDateString("pt-BR")} — ${sub.current_period_end ? new Date(sub.current_period_end).toLocaleDateString("pt-BR") : "—"}` : "—"}
                    </td>
                    <td className="p-4 text-xs text-muted-foreground">{new Date(sub.created_at).toLocaleDateString("pt-BR")}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminSubscriptionsTab;
